module.exports = __webpack_public_path__ + "img/32.afe8d559.svg";